"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
exports.__esModule = true;
var styles = [".form-control.is-invalid[_ngcontent-%COMP%], .was-validated[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:invalid{background-image:none!important}.loading-screen[_ngcontent-%COMP%]{-webkit-box-align:center;display:-webkit-box;-webkit-box-pack:center}"];
exports.styles = styles;
